import { render } from "./Input.vue?vue&type=template&id=3064de56&scoped=true"
import script from "./Input.vue?vue&type=script&lang=ts"
export * from "./Input.vue?vue&type=script&lang=ts"

import "./Input.vue?vue&type=style&index=0&id=3064de56&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-3064de56"

export default script